import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import {
  BusquedaTesoroNivelDetallePage,
  BusquedaTesoroNivelesPage,
  BusquedaTesoroCofrePage
} from '@pages';
import { AuthProvider } from '@providers/auth/auth';
import { BusquedaTesoroProvider } from '@providers/busqueda-tesoro/busqueda-tesoro';

@IonicPage()
@Component({
  selector: 'page-busqueda-tesoro-resultado-ronda',
  templateUrl: 'busqueda-tesoro-resultado-ronda.html',
})
export class BusquedaTesoroResultadoRondaPage {

  esCompletado: boolean;
  premio: any;
  nivel: any;
  preguntas: any;
  busquedaDelTesoro: any;
  avanceID: any;
  nombreSede: any;
  objetivo: any;
  equipo: any;
  jugador: any;

  readonly AUDIO_COFRE = 'assets/audios/busqueda-tesoro/gana_cofre.mp3';
  readonly AUDIO_LLAVE = 'assets/audios/busqueda-tesoro/gana_llave.mp3';
  readonly AUDIO_FALLIDO = 'assets/audios/busqueda-tesoro/nivel_fallido.mp3';

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private busquedaTesoroProvider: BusquedaTesoroProvider,
    private authProvider: AuthProvider,
  ) {
    this.esCompletado      = this.navParams.get('esCompletado');
    this.premio            = this.navParams.get('premio');
    this.preguntas         = this.navParams.get('preguntas');
    this.busquedaDelTesoro = this.navParams.get('busquedaDelTesoro');
    this.avanceID          = this.navParams.get('avanceID');
    this.nombreSede        = this.navParams.get('nombreSede');
    this.objetivo          = this.navParams.get('objetivo');
    this.nivel             = this.navParams.get('nivel');
  }

  async ionViewDidLoad() {
    this.equipo = await this.authProvider.getEquipo();
    this.jugador = await this.authProvider.getSession();

    let audio = new Audio();

    if(!this.esCompletado) {
      audio.src = this.AUDIO_FALLIDO;
    } else if(this.esCompletado && this.esLlave()) {
      audio.src = this.AUDIO_LLAVE;
    } else if(this.esCompletado && !this.esLlave()) {
      audio.src = this.AUDIO_COFRE;
    }
    
    audio.load();
    audio.play();
  }

  esLlave() {
    return this.esCompletado && this.premio.tipo == 'LLAVE';
  }

  async reintentar() {
    let response = await this.busquedaTesoroProvider.obtenPreguntasNivel(this.equipo.area._id, this.jugador._id);

    this.navCtrl.setRoot(BusquedaTesoroNivelDetallePage,{
      nombreSede: this.nombreSede,
      preguntas: response.preguntas,
      objetivo: this.objetivo,
      busquedaDelTesoro: this.busquedaDelTesoro,
      avanceID: this.avanceID,
      nivel:  this.nivel
    });
  }

  volverSedes() {
    this.navCtrl.setRoot(BusquedaTesoroNivelesPage ,{
      busquedaTesoro: this.busquedaDelTesoro
    })
  }

  verTesoro() {
    this.navCtrl.push(BusquedaTesoroCofrePage, {
      nivel: this.premio
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/busqueda-tesoro-resultado-ronda/busqueda-tesoro-resultado-ronda.ts